// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

// Starter Custom Code - >
import { IconWrapper } from "@insite/mobius/Icon/Icon";
import { StyledClickable, StyledTypography } from "@insite/mobius/Link";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import zoneElementsSelector from "@store/Framework/Common/Utilities/zoneElementsSelector";
import zoneNestedElementsSelector from "@store/Framework/Common/Utilities/zoneNestedElementsSelector";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
// <--- Starter Custom Code

/* Store Custom Code - Start */
import Accordion from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import ManagedAccordionSection from "@insite/mobius/AccordionSection/ManagedAccordionSection";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { accordionFooterSectionProps } from "@store/Themes/common/props/accordionFooter";

const enum fields {
    firstColumnTitle = "firstColumnTitle",
    secondColumnTitle = "secondColumnTitle",
}

/* Store Custom Code - End */

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
    // Starter Custom
    footerContainer?: InjectableCss;
    footerLegalStyledWrapper?: InjectableCss;
    topWrapper?: InjectableCss;
    bottomWrapper?: InjectableCss;
    topLeftWrapper?: InjectableCss;
    topGridContainer?: GridContainerProps;
    topLeftGridItem?: GridItemProps;
    topRightGridItem?: GridItemProps;
    bottomGridContainer?: GridContainerProps;
    bottomLeftGridItem?: GridItemProps;
    bottomCenterGridItem?: GridItemProps;
    bottomRightGridItem?: GridItemProps;
    contactWrapper?: InjectableCss;
    linkListGridItem?: GridItemProps;
    // Store Custom Code
    hidden?: HiddenProps;
    accordionSection?: AccordionSectionPresentationProps;
    columnTitle?: TypographyPresentationProps;
    socialMobile?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: [12, 12, 6, 4, 4], // Store Custom Code
        css: css`
            /* Store Custom Code - Start */
            padding: 0 0 0 ${pxToRem(36)};
            border-left: 1px solid ${getColor("common.borderLight")};

            /* Store Custom Code - End */
        `,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    footerContainer: {
        css: css`
            background-color: ${getColor("common.shadesLight")}; /* Store Custom Code */

            ${StyledClickable} {
                color: inherit;

                > ${StyledTypography} {
                    color: inherit;
                    font-weight: ${({ theme }) => theme.design.typography.weight.base};
                }

                &:hover {
                    text-decoration: underline;

                    > ${StyledTypography} {
                        color: inherit;
                    }
                }
            }
        `,
    },
    footerLegalStyledWrapper: {
        css: css`
            background-color: ${getColor("common.shadesMedium")}; /* Store Custom Code */
        `,
    },
    topWrapper: {
        css: css`
            padding-top: ${pxToRem(50)}; /* Store Custom Code */
            ${siteWidthStyles()}

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: ${pxToRem(35)};
                        `,
                        null,
                        css`
                            padding-bottom: ${pxToRem(50)}; /* Store Custom Code */
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    bottomWrapper: {
        css: css`
            ${siteWidthStyles()}
            line-height: ${({ theme }) => theme.design.typography.lineHeight.small};

            ${StyledClickable} {
                > ${StyledTypography} {
                    font-weight: ${({ theme }) => theme.design.typography.weight.base};
                }
            }

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-top: ${pxToRem(16)};
                            padding-bottom: ${pxToRem(16)}; /* Store Custom Code */
                        `,
                        null,
                        css`
                            padding-top: ${pxToRem(10)};
                            padding-bottom: ${pxToRem(10)};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    topLeftGridItem: {
        width: [12, 12, 2, 2, 2], // Store Custom Code
        align: "top", // Store Custom Code
    },
    topLeftWrapper: {
        css: css`
            width: 100%;
        `,
    },
    topRightGridItem: {
        width: [12, 12, 10, 10, 10], // Store Custom Code
        css: css`
            width: 100%;
        `,
    },
    bottomGridContainer: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smaller};
            color: ${getColor("text.input")};
        `,
        gap: 0, // Store Custom Code
    },
    bottomLeftGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: ${pxToRem(8)};
                        `,
                        null,
                        css`
                            padding-bottom: 0;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    bottomRightGridItem: {
        width: [12, 12, 8, 8, 8], // Store Custom Code
        css: css`
            /* Store Custom Code - Start */
            div {
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                text-align: left;
                            `,
                            null,
                            css`
                                text-align: right;
                            `,
                        ],
                        mediaOptions.min,
                    )}
            }

            /* Store Custom Code - End */
        `,
    },
    contactWrapper: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 80%;
                            margin: ${pxToRem(20)} auto;
                            padding-top: ${pxToRem(20)};
                            line-height: ${({ theme }) => theme.design.typography.lineHeight.small};
                        `,
                        null,
                        css`
                            width: 50%;
                            max-width: ${pxToRem(290)};
                            margin: ${pxToRem(20)} 0 0;
                            padding-top: ${pxToRem(25)};
                            line-height: ${({ theme }) => theme.design.typography.lineHeight.large};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    linkListGridItem: {
        width: [12, 12, 3, 4, 4], // Store Custom Code
        css: css`
            padding: 0;
            flex-direction: column; /* Store Custom Code */

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: ${pxToRem(55)};
                            text-align: center;

                            ${zoneNestedElementsSelector} {
                                text-align: center;
                            }
                        `,
                        null,
                        css`
                            padding-bottom: 0;

                            ${zoneNestedElementsSelector} {
                                text-align: left;
                            }
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    topGridContainer: {
        css: css`
            margin-top: ${pxToRem(10)};
        `,
    },
    /* Store Custom Code - Start */
    hidden: {
        css: css`
            width: 100%;
        `,
    },
    accordionSection: accordionFooterSectionProps,
    columnTitle: {
        forwardAs: "p",
        css: css`
            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.base};
                font-weight: ${theme.design.typography.weight.bold};
                ${contentSpacingStyles(0, 0, pxToRem(24), 0)}
            `}
        `,
    },
    socialMobile: {
        css: css`
            padding-top: ${pxToRem(24)};
        `,
    },
    logoWrapper: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-top: ${pxToRem(36)};
                        `,
                        null,
                        css`
                            padding-top: 0;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    /* Store Custom Code - End */
};

const FooterContainer: FC<OwnProps> = ({
    id,
    extendedStyles,
    fields: { firstColumnTitle, secondColumnTitle }, // Store Custom Code
}) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    return (
        // Starter Custom Code
        <StyledWrapper {...styles.footerContainer}>
            <StyledWrapper {...styles.topWrapper}>
                {/* Store Custom Code - Start */}
                <Hidden below="md" {...styles.hidden}>
                    <GridContainer>
                        <GridItem {...styles.topLeftGridItem}>
                            <StyledWrapper {...styles.topLeftWrapper}>
                                <StyledWrapper {...styles.logoWrapper}>
                                    <Zone zoneName="Logo" contentId={id} />
                                </StyledWrapper>
                            </StyledWrapper>
                        </GridItem>
                        <GridItem {...styles.topRightGridItem}>
                            <GridContainer {...styles.topGridContainer}>
                                <GridItem {...styles.linkListGridItem}>
                                    <Typography {...styles.columnTitle}>{firstColumnTitle}</Typography>
                                    <Zone zoneName="List1" contentId={id} />
                                </GridItem>
                                <GridItem {...styles.linkListGridItem}>
                                    <Typography {...styles.columnTitle}>{secondColumnTitle}</Typography>
                                    <Zone zoneName="List12" contentId={id} />
                                </GridItem>
                                <GridItem {...styles.socialLinksGridItem}>
                                    <Zone zoneName="Social" contentId={id} />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </Hidden>
                <Hidden above="sm" {...styles.hidden}>
                    <Accordion headingLevel={6}>
                        <ManagedAccordionSection
                            title={firstColumnTitle}
                            uid="footer-accordion-1"
                            initialExpanded={true}
                            {...styles.accordionSection}
                        >
                            <Zone zoneName="List1" contentId={id} />
                        </ManagedAccordionSection>
                        <ManagedAccordionSection
                            title={secondColumnTitle}
                            uid="footer-accordion-2"
                            initialExpanded={true}
                            {...styles.accordionSection}
                        >
                            <Zone zoneName="List12" contentId={id} />
                        </ManagedAccordionSection>
                        <StyledWrapper {...styles.socialMobile}>
                            <Zone zoneName="Social" contentId={id} />
                        </StyledWrapper>
                        <StyledWrapper {...styles.logoWrapper}>
                            <Zone zoneName="Logo" contentId={id} />
                        </StyledWrapper>
                    </Accordion>
                </Hidden>
                {/* Store Custom Code - End */}
            </StyledWrapper>
            <StyledWrapper {...styles.footerLegalStyledWrapper}>
                <StyledWrapper {...styles.bottomWrapper}>
                    <GridContainer {...styles.bottomGridContainer}>
                        <GridItem {...styles.bottomLeftGridItem}>
                            <Zone zoneName="FooterLegalZone" contentId={id} />
                        </GridItem>
                        {/* Store Removed Code - bottomCenterGridItem */}
                        <GridItem {...styles.bottomRightGridItem}>
                            <Zone zoneName="FooterLegalLinks" contentId={id} /* Store Custom Code */ />
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
        //  <--- Absolunet Custom  Code
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
        /* Store Custom Code - Start */
        fieldDefinitions: [
            {
                name: fields.firstColumnTitle,
                displayName: "First Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
            {
                name: fields.secondColumnTitle,
                displayName: "Second Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
        ],
        /* Store Custom Code - End */
    },
};

export default footerContainer;
